import { HelpMessage } from 'utils/constants'
import CIMSTable from 'components/CIMSTable'
import { ConcreteTestSet } from '../../../ConcreteTestSetTrackerContext/types'

const Material: React.FC<
  Pick<ConcreteTestSet, 'concreteMaterial' | 'globalId'>
> = ({ globalId, concreteMaterial }) => {
  if (!concreteMaterial) return null
  const help = HelpMessage.Concrete.ConcreteTestSetTracker.Material
  return (
    // This div is needed to prevent awkward placement of the scrollbar.
    <div>
      <CIMSTable
        disable={{ showAll: true }}
        records={[concreteMaterial]}
        rowKey={({ __typename }) => `${globalId}-${__typename}`}
        columns={[
          {
            title: 'Placement Type',
            help: help.PlacementType,
            width: 165,
            render: 'placementType',
          },
          {
            title: 'Spec Break Strength',
            help: help.SpecBreakStrength,
            width: 184,
            render: 'specBreakStrength',
          },
          {
            title: 'Max Break Strength',
            help: help.MaxBreakStrength,
            width: 180,
            render: 'maximumBreakStrength',
          },
          {
            title: 'Min Break Strength',
            help: help.MinBreakStrength,
            width: 180,
            render: 'lowFailureBreakStrength',
          },
          {
            title: 'Testing Frequency',
            help: help.TestingFrequency,
            width: 205,
            render: ({
              airSlumpStartup = 0,
              airSlumpTestingFrequency = 0,
              airTestsPer = 0,
              airUnits = 'n/a',
            }) =>
              `${airSlumpStartup} Startup and ${airSlumpTestingFrequency} Per ${airTestsPer} ${airUnits}`,
          },
        ]}
      />
    </div>
  )
}

export default Material
